import * as AzureService from "../api/ticketsApiAzure";
import * as tConst from "../common/Constants";

export const createChildrenTicket = (auth, selectedTicket, team, onRefreshChildren, prefix, children) => {
    const _teamSetting = tConst.TEAMS_LIST.filter((item) => item.team === team)?.[0];

    if (!_teamSetting) {
        console.warn("Team settings not found for team:", team);
        return;
    }

    const relation = children ? tConst.AF_REL_CHILD : tConst.AF_REL_SUCCESSOR; 

    // Create Ticket in Team project, with the same title with prefix and link to the selected ticket
    const _datalist = [
        { attribute: tConst.AF_TITLE, value: prefix + selectedTicket.fields[tConst.AF_TITLE] },
        { attribute: relation, value: selectedTicket.id },
        { attribute: tConst.AF_INITIATIV, value: selectedTicket.fields[tConst.AF_INITIATIV] },
        { attribute: tConst.AF_START_ITERATION, value: selectedTicket.fields[tConst.AF_START_ITERATION] },
        { attribute: tConst.AF_END_ITERATION, value: selectedTicket.fields[tConst.AF_END_ITERATION] }
    ];

    AzureService.createTicket(auth, _teamSetting.project, _teamSetting.ticketType, _datalist)
        .then((response) => {
            const _newTicketId = response.id;
            const _updateData = [
                { attribute: tConst.AF_ASSIGNED_TO, value: _teamSetting.defaultAssignee }
            ];

            AzureService.updateTicket(auth, _newTicketId, _updateData)
                .then(() => {
                    onRefreshChildren();
                })
                .catch((error) => {
                    console.warn("Error setting Assignee: ", error);
                });

            onRefreshChildren();
        })
        .catch((error) => {
            console.error("Error creating ticket: ", error);
        });
};